import React, { useState, useEffect, useCallback, useContext } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'
import DatePicker, { CalendarContainer } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { AppColors } from '../css/AppColors';
import { Modal, Button } from 'react-bootstrap';
import { apiRequest } from '../utils/apiCalls';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { useHistory, useLocation } from 'react-router';
import { getStoreData, getStoreDataFromLocal } from '../utils/functions';
// import { reactLocalStorage } from 'reactjs-localstorage';



const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}



const EditManufactur = () => {


    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const location = useLocation();
    const [startDate, setStartDate] = useState(new Date());

    const { state,  setManufactursGlobal } = useContext(Context)


    const [loading, setLoading] = useState(false)
    const ls = location?.state ? location.state : null
    const [manufacturData, setManufacturData] = useState({
        pb_name: ls ? ls.pb_name : '',
        pb_description: ls ? ls.pb_description : '',
        pb_status: ls ? ls.pb_status : '',
        st_id: state.storeData.st_id,
        pb_id: ls?.pb_id
    })



    useEffect(() => {


        // console.log('asd')
        // getStoreDataFromLocal()
        //     .then(data => {
        //         console.log('data = = = ')
        //         console.log(data)
        //     })

    }, [])

    function addManufactur() {

        if (manufacturData.pb_name == '') {
            alert('Please enter a manufactur name')
            return
        }
        if (manufacturData.pb_description == '') {
            alert('Please enter a manufacture description')
            return
        }

        setLoading(true)
        apiRequest(manufacturData, 'editManufactur')
            .then(data => {
                setLoading(false)
                console.log(data)
                if (data.status == 1) {
                    // alert('Customer Added')
                    if (data.manufacturs) {
                        setManufactursGlobal(data.manufacturs);
                    }
                    history.replace('/viewManufactur')
                    

                }
                else {
                    alert(data.error)
                }
            })
            .catch(err => {
                setLoading(false)
                // console.log(err)
                alert('Internet Error')
            })



    }



    return (
        <div id="page-top">
            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={loading}
                                onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>
                            {/* Page Wrapper */}
                            <div id="wrapper" >
                                {/* Content Wrapper */}
                                <div id="content-wrapper" className="d-flex flex-column" style={{ paddingBottom: 200 }} >
                                    {/* Main Content */}
                                    <div id="content">
                                        {/* Begin Page Content */}
                                        <div className="container-fluid">
                                            {/* Page Heading */}
                                            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                                <h1 className="h3 mb-0 text-gray-800">View Manufactur</h1>
                                            </div>
                                            <div className="row">
                                                {/* <form id="frm_customer"> */}

                                                <div className="form-group row">
                                                    <div className="col-sm-6">
                                                        <div className="editDetails" >Manufactur Name</div>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-user"
                                                            value={manufacturData.pb_name}
                                                            onChange={(t) => {
                                                                setManufacturData({
                                                                    ...manufacturData,
                                                                    pb_name: t.target.value
                                                                })
                                                                forceUpdate();
                                                            }}

                                                        />
                                                        <br />
                                                    </div>
                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Manufactur Description</div>
                                                        <input
                                                            className="form-control form-control-user"
                                                            value={manufacturData.pb_description}
                                                            onChange={(t) => {
                                                                setManufacturData({
                                                                    ...manufacturData,
                                                                    pb_description: t.target.value
                                                                })
                                                                forceUpdate();
                                                            }}
                                                        />
                                                        <br />
                                                    </div>


                                                    <div className="col-sm-6 mb-3 mb-sm-0">
                                                        <div className="editDetails" >Status</div>
                                                        <select
                                                            className="form-control form-control-user"
                                                            placeholder="Best Contact"
                                                            onChange={(t) => {
                                                                setManufacturData({
                                                                    ...manufacturData,
                                                                    pb_status: t.target.value
                                                                })
                                                                forceUpdate();
                                                            }}

                                                        >
                                                            <option selected disabled>
                                                                Select
                                                            </option>
                                                            <option selected={manufacturData.pb_status == '1' ? true : false} value={1}>Active</option>
                                                            <option selected={manufacturData.pb_status == '0' ? true : false} value={0}>Inactive</option>

                                                        </select>
                                                        <br />
                                                    </div>

                                                    <Button
                                                        id="add_customer"
                                                        className="btn btn-primary btn-user btn-block rBBtn"
                                                        onClick={() => addManufactur()}
                                                        style={{ backgroundColor: AppColors.primary, borderWidth: 0, fontFamily: 'RBo' }}
                                                    >
                                                        Save
                                                    </Button>
                                                    {/* </form> */}
                                                </div>
                                            </div>
                                            {/* /.container-fluid */}
                                        </div>
                                        {/* End of Main Content */}
                                    </div>
                                    {/* End of Content Wrapper */}
                                </div>
                                {/* End of Page Wrapper */}
                                {/* Scroll to Top Button*/}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditManufactur
